import AI_assistant from './src/views/AIAssistant.vue';
export default AI_assistant;